module.exports = __webpack_public_path__ + "img/Group 8723.4e7ad262.svg";